/**
 * Removes HTML tags and angle brackets from plain-text input.
 * @param {unknown} value
 * @returns {unknown}
 */
export function stripHtml(value) {
  if (typeof value !== 'string') return value;
  return value.replace(/<[^>]*>/g, '').replace(/[<>]/g, '');
}

/**
 * Builds safe label HTML for form fields that need a mandatory asterisk.
 * @param {string} label
 * @param {string|number} mandatory
 * @returns {string}
 */
export function buildFieldLabelHtml(label, mandatory) {
  const safeLabel = stripHtml(label ?? '');
  if (mandatory === '1' || mandatory === '2') {
    return `${safeLabel} <span class='mandatory-mark'>*</span>`;
  }
  return safeLabel;
}

/**
 * Label HTML for display: strip tags, then allow line breaks as <br>.
 * @param {unknown} label
 * @returns {string}
 */
export function formatLabelHtmlForDisplay(label) {
  if (label == null || label === '') return '';
  let s = stripHtml(String(label));
  if (/^ckyc$/i.test(s.trim())) {
    s = 'Kyc';
  }
  s = s.replace(/\r\n/g, '<br>').replace(/\r/g, '<br>').replace(/\n/g, '<br>');
  s = s.replace(/\\r\\n/g, '<br>').replace(/\\n/g, '<br>').replace(/\\r/g, '<br>');
  return s;
}

/**
 * Error text safe for innerHTML (escape remaining special chars after stripHtml).
 * @param {unknown} msg
 * @returns {string}
 */
export function formatErrorMsgHtml(msg) {
  if (msg == null || msg === '') return '';
  let s = stripHtml(String(msg));
  s = s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
  s = s.replace(/\r\n/g, '<br>').replace(/\r/g, '<br>').replace(/\n/g, '<br>');
  s = s.replace(/\\r\\n/g, '<br>').replace(/\\n/g, '<br>').replace(/\\r/g, '<br>');
  return s;
}
